/* eslint-disable unicode-bom */
import { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

const regionSlugs = { EU: "eu", FR: "fr", US: "" };

export default function RegionGuard({ region }) {
  const history = useHistory();
  const { pathname } = useLocation();
  const parts = pathname.split("/").filter(Boolean).map(p => p.toLowerCase());
  const current = parts[0];
  const targetSlug = regionSlugs[region.toUpperCase()];

  useEffect(() => {
    // If already correct, do nothing
    if (current === targetSlug) return;

    // US: remove any region prefix
    if (region.toUpperCase() === "US" && ["eu", "fr"].includes(current)) {
      return history.replace("/" + parts.slice(1).join("/"));
    }

    // For EU/FR: always remove all region prefixes and add the correct one
    if (["EU", "FR"].includes(region.toUpperCase())) {
      const rest = parts.filter(p => !["eu", "fr"].includes(p));
      return history.replace(`/${targetSlug}/${rest.join("/")}`.replace(/\/+/g, "/"));
    }
    // Otherwise, do nothing
  }, [pathname, region, current, targetSlug, history, parts]);

  return null;
}
